import { render, staticRenderFns } from "./BasicBox.vue?vue&type=template&id=0d1563dc&"
import script from "./BasicBox.vue?vue&type=script&lang=js&"
export * from "./BasicBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports